import Head from 'next/head';
import PlainBanner from '../../components/common/PlainBanner';
import { Fragment } from 'react';
import Form from '../../components/contact-us/Form';
import { GetSubIssues } from '../../api/contact-us/index';
import { useEffect } from 'react';
import {trackPage} from "../../tracking/index";
import { useRouter } from 'next/router';
import Config from '../../config';
import {getStaticPath} from '../../utils';
import { connect } from 'react-redux';
import { getPageViewData } from '../../utils/tracking';
import { WebsiteSchema } from '@/constants/schema';
import SchemaLoader from '@/components/hoc/SchemaLoader';
import page_data from '../../data/page_data';


export async function getServerSideProps()
{
    const res:any = await GetSubIssues();
    return {
      props:
      {
        subissues:res? res.data : {},
        meta_tag_data:  page_data['contact-us'].meta_tag ?  page_data['contact-us'].meta_tag : [],
        pageName: 'write-to-us'
      }
    }
}


const Home = (props:any) => {
  const router = useRouter();
  const BASE_URL = Config.BASE_URL;
  const OG_IMAGE = getStaticPath("/static/images/contactus/group-17.png")
   useEffect(()=>{
    // loadChatBotConfig()
    trackPage("Contact Us Page",{...getPageViewData()})
   }, [])
    return(
        <Fragment>
          <Head>
            <title>{props.meta_tag_data.tag_title}</title>
            <link rel="icon" href="/favicon.ico" />
            <meta name="description" content={props.meta_tag_data.tag_description}></meta>
            <meta property="og:title" content={props.meta_tag_data.tag_title}/>
            <meta property="og:description" content={props.meta_tag_data.tag_description}/>
            <meta property="og:url" content={`${BASE_URL}${router.asPath}`}/>
            <meta property="og:image" content={OG_IMAGE}/>
            <link rel="canonical" href={`${BASE_URL}${router.asPath}`}></link>
            <SchemaLoader schema={WebsiteSchema} />
          </Head>
          <PlainBanner className="contact-us" title="Contact Us - Onsitego" subtitle="">
          </PlainBanner>

          <div className='odd-even-start-with-white'>
            <Form {...props}/>
          </div>

      </Fragment>
    )
}

function mapStateToProps(state) {
  return {
      customer : state.customerReducer
  };
}
export default connect(mapStateToProps)(Home);
